import { useCallback, useMemo, useState } from "react";

import { AgencyNoticesDialog } from "./agency-notices-dialog";

export const useAgencyNoticesDialogViewModel = ({
  agencyNotices,
  onClose,
  onDismiss,
}: React.ComponentPropsWithoutRef<typeof AgencyNoticesDialog>) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [
    agencyNoticeTokensToDismiss,
    setAgencyNoticeTokensToDismiss,
  ] = useState<string[]>([]);

  const activeAgencyNotice = useMemo(() => {
    if (agencyNotices.length === 0 || activeIndex > agencyNotices.length - 1) {
      return null;
    }

    return agencyNotices[activeIndex];
  }, [activeIndex, agencyNotices]);

  const handleBack = useCallback(() => {
    setActiveIndex((prev) => prev - 1);
  }, []);

  const handleClose = useCallback(() => {
    onClose();
  }, []);

  const handleContinue = useCallback(() => {
    if (!activeAgencyNotice) {
      return;
    }

    setAgencyNoticeTokensToDismiss((prev) => [
      ...prev,
      activeAgencyNotice.token,
    ]);

    if (activeIndex === agencyNotices.length - 1) {
      onClose();

      for (const agencyNoticeToken of agencyNoticeTokensToDismiss) {
        onDismiss(agencyNoticeToken);
      }

      onDismiss(activeAgencyNotice.token);

      setAgencyNoticeTokensToDismiss([]);

      return;
    }

    setActiveIndex((prev) => prev + 1);
    setAgencyNoticeTokensToDismiss((prev) => [
      ...prev,
      activeAgencyNotice.token,
    ]);
  }, [
    activeIndex,
    activeAgencyNotice,
    agencyNotices,
    agencyNoticeTokensToDismiss,
    onClose,
    onDismiss,
  ]);

  const isIndexActiveIndex = useCallback(
    (index: number) => {
      return activeIndex === index;
    },
    [activeIndex],
  );

  const shouldDisableBackButton = useMemo(() => {
    return activeIndex === 0;
  }, [activeIndex]);

  const shouldDisableContinueButton = useMemo(() => {
    return false;
  }, []);

  return {
    activeAgencyNotice,
    handleBack,
    handleClose,
    handleContinue,
    isIndexActiveIndex,
    shouldDisableBackButton,
    shouldDisableContinueButton,
  };
};
